import React from 'react';
export function asInlineSVG(icon) {
    return function () { return React.createElement("span", { dangerouslySetInnerHTML: { __html: icon } }); };
}
//# sourceMappingURL=InlineSvg.js.map